function adicionarReticencias(texto, limite = 15) {
	if (texto == null) return "";
	return String(texto).length > limite ? String(texto).substring(0, limite) + "..." : texto;
}

export { adicionarReticencias };
